var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useRef } from 'react';
export const View = React.forwardRef((_a, ref) => {
    var { onTouchStart, onTouchEnd, onLongTouch, onTouchCancel, onMouseDown, onMouseUp, children } = _a, restProps = __rest(_a, ["onTouchStart", "onTouchEnd", "onLongTouch", "onTouchCancel", "onMouseDown", "onMouseUp", "children"]);
    const touchStartTime = useRef(0);
    const mouseDownTime = useRef(0);
    const handleTouchStart = useCallback((e) => {
        touchStartTime.current = Date.now();
        onTouchStart && onTouchStart(e);
    }, [onTouchStart]);
    const handleTouchEnd = useCallback((e) => {
        onTouchEnd && onTouchEnd(e);
        const touchEndTime = Date.now();
        if (touchEndTime - touchStartTime.current >= 500) {
            onLongTouch && onLongTouch(e);
        }
    }, [onTouchEnd, onLongTouch]);
    const handleTouchCancel = useCallback((e) => {
        onTouchCancel && onTouchCancel(e);
        const touchEndTime = Date.now();
        if (touchEndTime - touchStartTime.current >= 500) {
            onLongTouch && onLongTouch(e);
        }
    }, [onTouchCancel, onLongTouch]);
    const handleMouseDown = useCallback((e) => {
        onMouseDown && onMouseDown(e);
        mouseDownTime.current = Date.now();
    }, [onMouseDown, mouseDownTime]);
    const handleMouseUp = useCallback((e) => {
        onMouseUp && onMouseUp(e);
        const mouseUpTime = Date.now();
        if (mouseUpTime - mouseDownTime.current >= 500) {
            onLongTouch && onLongTouch(e);
        }
    }, [onMouseUp, onLongTouch]);
    return (React.createElement("div", Object.assign({ ref: ref, onTouchStart: handleTouchStart, onTouchEnd: handleTouchEnd, onTouchCancel: handleTouchCancel, onMouseDown: handleMouseDown, onMouseUp: handleMouseUp }, restProps), children));
});
View.displayName = 'View';
export default View;
